/*
 * Email logs "Download CSV": the teacher list as filtered and sorted on screen. No recipient
 * address (the list never carries one). Pure; csv.test.js.
 */
import { csv_file_name } from '../../../util_components/csv_export/to_csv';
import { bare } from '../payouts/csv';

export const email_logs_csv_name = (pay_month) => () =>
  csv_file_name({ page: 'Email logs', table: 'Teachers', period: pay_month });

// teacher_rows_view rows; the month is the tab's, so every row carries it.
export const email_logs_columns = (pay_month) => [
  { header: 'Teacher', value: (r) => bare(r.teacher_name) },
  { header: 'Teacher slug', key: 'teacher_slug' },
  { header: 'Teacher UUID', key: 'teacher_uuid' },
  { header: 'Pay month', value: () => pay_month || '' }
];
